import BlocksContext from '../contexts/BlocksContext';
import { useContext } from 'react';

export const useBlocksContext = () => {
  return useContext(BlocksContext);
};
